import { CheckCircle2 } from "lucide-react";
import { BtnLink, Eyebrow, Reveal } from "@/components/site/Primitives";
import { useLink, useT } from "@/lib/i18n";

export function ThankYou() {
  const t = useT();
  const link = useLink();
  const th = t.thanks;
  return (
    <section data-testid="thanks-page" className="container-x pb-24 pt-36 sm:pt-44">
      <Reveal>
        <div className="mx-auto max-w-3xl text-center">
          <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-forest text-gold-light"><CheckCircle2 size={34} strokeWidth={1.4} /></span>
          <h1 className="mt-8 font-display text-4xl leading-tight text-forest sm:text-6xl" data-testid="thanks-title">{th.title}</h1>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-forest/80 sm:text-lg">{th.text}</p>
        </div>
      </Reveal>
      <div className="card-soft mx-auto mt-14 max-w-3xl p-8 sm:p-12">
        <Eyebrow>{th.nextTitle}</Eyebrow>
        <ol className="mt-6 space-y-5">
          {th.next.map((n, i) => (
            <li key={n} className="flex items-start gap-5">
              <span className="font-display text-3xl italic text-gold-text">0{i + 1}</span>
              <span className="pt-1.5 text-[15px] leading-relaxed text-forest sm:text-base">{n}</span>
            </li>
          ))}
        </ol>
        <p className="mt-8 border-l-2 border-gold pl-4 text-sm text-forest/75">{t.discovery.note}</p>
        <BtnLink to={link("home")} variant="forest" className="mt-10" data-testid="thanks-home-btn">{th.home}</BtnLink>
      </div>
    </section>
  );
}

export function Legal({ kind }) {
  const t = useT();
  const doc = t.legal[kind];
  return (
    <section data-testid={`${kind}-page`} className="container-x pb-24 pt-36 sm:pt-44">
      <div className="mx-auto max-w-3xl">
        <h1 className="font-display text-5xl text-forest sm:text-6xl">{doc.title}</h1>
        <p className="mt-6 rounded-2xl border border-dashed border-gold-deep/60 bg-gold/10 px-5 py-4 text-sm text-forest" data-testid="legal-pending-note">{t.legal.pending}</p>
        <div className="mt-10 space-y-10">
          {doc.sections.map((s) => (
            <div key={s.h}>
              <h2 className="font-display text-3xl text-forest">{s.h}</h2>
              <p className="mt-3 text-base leading-relaxed text-forest/80">{s.p}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function NotFound() {
  const t = useT();
  const link = useLink();
  return (
    <section data-testid="notfound-page" className="container-x flex min-h-[70vh] flex-col items-start justify-center pt-32">
      <p className="font-display text-8xl italic text-gold-text">404</p>
      <h1 className="mt-4 font-display text-4xl text-forest sm:text-5xl">{t.notfound.title}</h1>
      <BtnLink to={link("home")} variant="forest" className="mt-8" data-testid="notfound-home-btn">{t.notfound.cta}</BtnLink>
    </section>
  );
}
